import { z } from 'zod'

import { DateZod } from '../date-zod'
import { GooglePlaceDetailsZod } from '../google'

export const DONATION_STATUS = {
  COMPLETED: 3,
}
export const PiloteTransportRequestStatusZod = z.enum([
  'PENDING',
  'ASSIGNED',
  'ALLOCATED',
  'ON_BOARD',
  'COMPLETED',
  'UNFINDABLE',
  'CANCELLED',
  'TRANSFERRED',
])
export type PiloteTransportRequestStatus = z.infer<typeof PiloteTransportRequestStatusZod>
export const PiloteTransportRequestRecordZod = z.object({
  id: z.number(),
  uuid: z.string().min(8),
  central_id: z.number(),
  evening_id: z.number(),
  team_id: z.number().nullable(),
  status: PiloteTransportRequestStatusZod,
  version: z.number(),
  creation_date: DateZod,
  assignment_date: DateZod.nullable(),
  allocation_date: DateZod.nullable(),
  onboard_date: DateZod.nullable(),
  completion_date: DateZod.nullable(),
  last_modification_date_by_team: DateZod.nullable(),
  last_modified_by_team_id: z.number().nullable(),

  assigned_by: z.number().nullable(),

  first_name: z.string(),
  last_name: z.string(),
  phone_number: z.string().nullable(),
  cell_number: z.string().nullable(),

  origin_latitude: z.number().nullable(),
  origin_longitude: z.number().nullable(),
  origin_place_details: GooglePlaceDetailsZod.nullable(),
  destination_latitude: z.number().nullable(),
  destination_longitude: z.number().nullable(),
  destination_place_details: GooglePlaceDetailsZod.nullable(),

  origin_street_address: z.string().nullable(),
  origin_city: z.string().nullable(),
  origin_province: z.string().nullable(),
  origin_postal_code: z.string().nullable(),

  destination_street_address: z.string(),
  destination_city: z.string(),
  destination_province: z.string().nullable(),
  destination_postal_code: z.string().nullable(),

  vehicle_manufacturer: z.string(),
  vehicle_type: z.number().nullable(),
  vehicle_color: z.number(),
  vehicle_model: z.string(),

  notes: z.string().nullish().default(''),
  special_code: z.string().nullish().default(''),

  vehicle_nb_of_passengers: z.number(),
  vehicle_nb_of_seat_belts: z.number(),

  donation: z.number().nullable(),
  donation_status: z.number(),
  donation_date: DateZod.nullable(),

  communicated_waiting_time: z.number().nullable(),
  institution_name: z.string().nullable(),

  has_receipt: z.boolean(),
  is_manual_vehicle: z.boolean().nullable(),
  is_french_communication: z.boolean().nullable(),
  is_accepted: z.boolean().nullable(),
  is_entered_sms_was_sent: z.boolean().nullable(),
  is_allocated_sms_was_sent: z.boolean().nullable(),
  is_excluded_from_assisted_assignment: z.boolean().nullable(),
})
